//
// accordéons de la page agenda : Christophe Bernard
//

const accordion = {
	init(){
		let accordions = document.querySelectorAll('.accordion');
		let mqDesktop = window.matchMedia("(min-width: 1024px)").matches;
		
		accordions.forEach( accordion => {
			let title = accordion.querySelector('.accordion_title');
			
			accordion.dataset.accordionType == "type02" && mqDesktop ? accordion.dataset.accordionState ='open' : accordion.dataset.accordionState ='close';
			
			if ( title ) {
				title.onclick = () => {
					accordion.dataset.accordionState == 'close' ? this.open(accordion) : this.close(accordion)
				}
			}
		})
	},
	open(accordion){
		accordion.dataset.accordionState = "open";
		let content = accordion.querySelector('.accordion_content');
		content.style.maxHeight = content.scrollHeight + 'px';
	},
	close(accordion){
		accordion.dataset.accordionState = "close";
		accordion.querySelector('.accordion_content').style.maxHeight = null;
	}
}

export default accordion;


// WEBPACK FOOTER //
// ./src/scripts/components/accordion.js